import { FeatureDetails } from "components/FeatureDetails/FeatureDetails";
import {
  LockDescription,
  ModalDescriptionWrapper,
} from "../RevenueMetrics/RevenueMetricsLocked";
import { LockFeatures } from "../RevenueMetrics/RevenueMetricsLocked";
import { Button } from "components/DesignSystem/Button/Button";
import { BooksSoftwareSubscriptionsModal } from "components/BooksSoftwareSubscriptionsModal";
import { useCurrentEntityId } from "hooks/useCurrentEntityId";
import { useModal } from "hooks/useModal";
import FixedAssetsBanner from "static/images/FixedAssets.png";

export const LockedFixedAsset = () => {
  const entityId = useCurrentEntityId();
  const subscriptionModal = useModal();

  const featureDetails = [
    {
      type: "boxes",
      description: "Add and organize all your business assets in one place",
    },
    {
      type: "divider",
      description: "",
    },
    {
      type: "creditCard",
      description: "Automate depreciation with accurate schedules and methods",
    },
    {
      type: "divider",
      description: "",
    },
    {
      type: "bigData",
      description:
        "Generate ready-to-use accounting reports and journal entries",
    },
  ];
  const descriptionText =
    "Track, organize, and depreciate your assets effortlessly with automated schedules, journal entries, and reports";
  return (
    <section className="t-flex t-justify-center t-items-center t-h-full t-w-full">
      <FeatureDetails
        banner={
          <img
            className="t-w-[22.5625rem] t-h-[13.5rem] t-object-cover"
            src={FixedAssetsBanner}
            alt="BannerFixedAssets"
          />
        }
        description={
          <LockDescription
            descriptionText={descriptionText}
            title="Fixed Assets"
          />
        }
        feature={
          <div className="t-flex t-gap-5 t-w-[31.8125rem] sm:t-w-full sm:t-flex-col sm:t-gap-4 sm:t-max-h-none t-mx-auto t-items-center t-h-[82px] sm:t-h-auto">
            {featureDetails.map((feature, index) => (
              <LockFeatures
                key={index}
                type={feature.type}
                description={feature.description}
              />
            ))}
          </div>
        }
        button={
          <Button
            onClick={() => subscriptionModal.open()}
            customType="primary"
            size="regular"
          >
            Upgrade to Inkle Books Standard
          </Button>
        }
      />
      <BooksSoftwareSubscriptionsModal
        open={subscriptionModal.isOpen}
        onClose={() => subscriptionModal.close()}
        entityId={entityId}
        onProductSubscribe={() => subscriptionModal.close()}
        modalDescription={
          <ModalDescriptionWrapper value="Unlock Fixed Assets and more with Books Standard Plan" />
        }
      />
    </section>
  );
};
